import { Post } from "../utils/http.js"

export function getGoogleMapAddress(params) {
  return Post("/api/googleMap/near", params)
}
export function addAddress(params) {
  return Post("/api/order/consign/create", params, {
    loading: true
  })
}
export function modifyAddress(params) {
  return Post("/api/order/consign/modify", params, {
    loading: true
  })
}
export function deleteAddress(params) {
  return Post("/api/order/consign/del", params, {
    loading: true
  })
}
